
import './index.less'
import React from 'react'
import { useState } from 'react'

export default function Checkbok(props) {
  const [ifon, setIfon] = useState({
    list: [...props.list]
  })

  return (<div className='checkbok'>
    {props.children.map((Item, index) => {
      return React.cloneElement(Item, {
        id: Item.props.id,
        active: ifon.list.includes(Item.props.id),
        change(id) {
          if (ifon.list.includes(id)) {
            ifon.list = ifon.list.filter((item) => {
              return item !== id
            })
          } else {
            ifon.list.push(id)
          }
          props.change && props.change(ifon.list)
          setIfon({
            ...ifon
          })
        }
      })
    })}
  </div>)
}
